import React,{useEffect} from 'react'
import { Tabs, TabsProps } from 'antd';
import { useSelector } from 'react-redux';
import PendingRequestAtAdminTable from '../containers/PendingRequestAtAdmin/pendingRequestAtAdmin';
import ActiveUserTableContainer from '../containers/ActiveUserTableContainer/activeUsersTableContainer';
import InactiveUserTableContainer from '../containers/InactiveUserTableContainer/inactiveUserTableContainer';
import UserConfigContainer from '../containers/UserConfigContainer/userConfigContainer';
import { getUserRole } from '../utilities/CommonHelper';
import { getUserAccessData } from '../utilities/sessionHelper';

interface EmployeeRequest {
  id: number;
  type: string;
  employeeName: string;
  employeeEmail: string;
  employeeId: string;
  businessUnit: string;
  department: string;
  reportingManagerName: string;
  reportingManagerEmail: string;
  role: string;
  accessReason: string;
  reminderEmailCount: number;
  requestStatus: string;
  approvalRejects: any[];
}

const UserDashboard : React.FC=()=> {
  const [activetab,setactiveTab]=React.useState<string>('1');
  const [isLoading,setIsLoading]=React.useState<boolean>(false);
  const userDashboardData = useSelector((state: any) => state.userDashboard);
  const role= getUserRole(getUserAccessData()?.roleAccessMap)||"";

  useEffect(() => {
    console.log('userDashboardData',userDashboardData);
    setIsLoading(userDashboardData.loading);
  
  }, [userDashboardData.loading]);
  

    const items: TabsProps['items'] = [
      {
        key: '1',
        label: 'Pending Requests',
        children: <PendingRequestAtAdminTable activeTab={activetab}/>,
      },
      {
        key: '2',
        label: 'Active Users',
        children: <ActiveUserTableContainer activeTab={activetab}/>,
      },
      {
        key: '3',
        label: 'Inactive Users',
        children: <InactiveUserTableContainer activeTab={activetab}/>,
      },
      {
        key: '4',
        label: 'User Config',
        children: <UserConfigContainer activeTab={activetab}/>,
      }
    ];  

  return (
      <div className='containerr' style={{marginRight:'10px'}}>
        <h2 className='page-heading'>
          User Dashboard
        </h2>
        {/* {comment for testing} */}
        {/* {userDashboardData?.loading && <div> <p>loading...</p> </div>} */}
        <Tabs onChange={setactiveTab} items={role==="Admin"?
         items:
          items.filter((item)=>item.key!=="4")
          } defaultActiveKey="1" style={{paddingLeft:'20px'}}/>

        </div>
  )
}
export default UserDashboard;